"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'dblogs.error.fetch': 'Failed to load DB logs.',
};
